import {useState,useEffect, useContext} from 'react';
import axios from "axios"

import Meetings from './meetings';
import Meeting from './meeting';
import Vote from './vote';
import Login from './login';
// import Signup from './signup';
import LoginLogo from './loginLogo';
import Test from './test';
import Ndaer from './ndaer';
import Home from './home';
import Error from './error';
import Event from './event';
import Events from './events';
import Contacts from './contacts';
import Hub from './hub';
import MeetingContent from './meetingContent';
import MeetingMessages from './meetingMessages';
import MeetingVote from './meetingVote';
import EventContent from './eventContent';
import EventMessages from './eventMessages';
import EventVote from './eventVote';
import VidConf from './vidConf';
// import CreateMeeting from './createMeeting';
import {voteExtToggle , setVoteExtToggle} from './voteCard';
import NDA_URL_Key from '../middleware/URL_key';
// import Passage from "@passageidentity/passage-node";
// import "@passageidentity/passage-auth";
// import '@passageidentity/passage-elements/passage-register';
import { useCurrentUser } from "../hooks/useCurrentUser"
import {AppState, AppContext} from '../context/AppProvider'

import ComingSoon from './comingSoon';
import EnvRoute from '../middleware/envRoute';
// import  guestCredentials  from '../seeders/guestCredentials';
import { useRecordingStreaming } from '@100mslive/react-sdk';

const ENDPOINT = EnvRoute('prod'); 

// let meetings = require('../seeders/seedMeetings.json');
// const guest = guestCredentials


let events = require('../seeders/seedEvents.json');
let votes = require('../seeders/seedVotes.json');
// let meeting = JSON.parse(window.localStorage.getItem('meeting'))
// let event = JSON.parse(window.localStorage.getItem('event'))
// function getCardInfo(){
//   const PORT=3000
//   const MONGO_URI="mongodb://localhost:27017/meetings"
// }

  
  function Frame(props) {
    // const meetings = props.meetings
    // const votes = props.votes
    // let event = JSON.parse(localStorage.getItem("event"))
    // const username = props.user
    // const setView = props.setView()
    // let { isLoading, isAuthorized, username, p_user_id, re, user_metadata } = useCurrentUser();
    const {
      isLoggedIn,
      // view, 
      setView,
      room,
      setRoom,
      user,
      setUser,
      meetings,
      setMeetings,
      currentMeeting,
      setCurrentMeeting,
      events,
      setEvents,
      currentEvent,
      setCurrentEvent,
      currentVote,
      notifications,
      setNotifications,
      
      setIsLoading } = useContext(AppContext)
      let view = props.view
      // setView (p_view)
      // setUser(guest)
      // if(user){ setView('hub') }
      // if(!user){ 
        // console.log('No passage user info. back to login')
        // window.location.href = `/`
      // setView('home')
    //  }
    // else{localStorage.setItem('TH_user',JSON.stringify(user))}
    
    const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY0NTQwODY3NWJkZGRhYjZhZTAxODI4ZiIsImlhdCI6MTY4MzIyODc3NSwiZXhwIjoxNjg1ODIwNzc1fQ.R-mT12-OY0WApViLJF5dbmOa8oO1qd9SbKOTjfpGi-k"
    
    const fetchUser = async(email,token)=>{
      try {
        const config = {
          headers: {
          // Authorization: `Bearer ${user.token}`,//!---production
            Authorization: `Bearer ${user?.token}`,
          },
        };

        // setUser(guest);
        // console.log("pre fetch user: ", cur_user)
        const data  = await axios.post(`${ENDPOINT}/api/user/status`,{email: user?.email}, config)
        console.log("data.data: ", data.data)
        // setUser([...data.data]);
        setUser(data.data);
        // console.log("Meetings: ", meetings)
      } catch (err) {console.log(err)}
      
      }
    
   
    const [ prev_view , setPrevView] = useState('')
    const [ cur_user , set_cur_user] = useState(user.email)
    const [ h_logo_vis , set_h_logo_vis] = useState('true')
    const [ frameContent , setFrameContent] = useState('')
    const [ slidePos , setSlidePos] = useState('slide-down')
    const mm_btn_opn = 'frame-mm-button show-box blink'
    const mm_btn_vt_mv = 'frame-mm-button-vt-mv show-box blink'
    const mm_btn_vt_rst = 'frame-mm-button-reset show-box blink'
    const mm_btn_cls = 'frame-mm-button-close show-box blink'

    let meeting = currentMeeting? currentMeeting: undefined
    let event = currentEvent? currentEvent: undefined

    const [mmButtonClass , setmmButtonClass] = useState(mm_btn_vt_rst)
    console.log("[Frame] view:",view)
    const [showMeetingVid , setShowMeetingVid] = useState(false)
    const [showMeetingVidButton , setShowMeetingVidButton] = useState(false)
    
    const [ showSpaceButton , setShowSpaceButton ] = useState(false)
    const [ spaceViewPos , setSpaceViewPos ] = useState(false)
    const [ showSpaceView , setShowSpaceView ] = useState(false)

    const [ showMtgMsg , setShowMtgMsg] = useState(false)
    const [ MtgMsgPos , setMtgMsgPos] = useState(false)
    
    const [ showEventVidButton , setShowEventVidButton] = useState(false)
    const [ eventVidPos , setEventVidPos] = useState(false)
    const [ showEventVid , setShowEventVid ] = useState(false)
    
    const [ showEventContentButton , setShowEventContentButton] = useState(false)
    const [ eventContentPos , setEventContentPos] = useState(false)
    const [ showEventContent , setShowEventContent ] = useState(false)
    
    const [ showEventMessagesButton , setShowEventMessagesButton] = useState(false)
    const [ eventMessagesPos , setEventMessagesPos] = useState(false)
    const [ showEventMessages , setShowEventMessages ] = useState(false)
    
    const [ showEventVoteButton , setShowEventVoteButton] = useState(false)
    const [ eventVotePos , setEventVotePos] = useState(false)
    const [ showEventVote , setShowEventVote ] = useState(false)

    const [ showHubSlide, setShowHubSlide ] = useState(false)
    const [ hubSlidePos, setHubSlidePos] =useState (false)
    
    const [ mtgVtPos, setMtgVtPos] = useState(false)
    const [ mtgVtBox, setMtgVtBox] = useState(false)
    
    const [ vLinkMove , setVLinkMove] = useState('')
    const [ showMMButton , setShowMMButton] = useState(false)

    const [ viewer , setViewer] = useState({
      email: user.email,
      timestamp: new Date().toLocaleString(),
      geo_dat: JSON.parse(localStorage.getItem('geo_dat')),
      app:"Townhall"
    })
    
    // const API_URL = NDA_URL_Key('dep',0)
    const NDAER_ENDPOINT = 'https://ndaer-backend.onrender.com'

    let back_route=''
   
    function toggleSpaceView(){
      if(!showSpaceView){
        setShowSpaceView(true)
        setSpaceViewPos('slide-up')
        }else{
          setSpaceViewPos('slide-down')
          setShowSpaceView (false)}
          console.log("toggleSpaceView click")
        }
    function toggleHubSlide(){
      routeHome()
      // if(!showHubSlide){
      //   setShowHubSlide(true)
      //   setHubSlidePos('slide-up')
      //   }else{
      //     setHubSlidePos('slide-down')
      //     setShowHubSlide(false)}
      //     console.log("toggleHubSlide click")
        }
    function toggleEventVideo(){
      if(!showEventVid){
        setShowEventVid(true)
        setEventVidPos('slide-up')
        }else{
          setEventVidPos('slide-down')
          setShowEventVid(false)}
          console.log("toggleEventVid click")
        }
    function toggleEventContent(){
      if(!showEventContent){
        setShowEventContent(true)
        setEventContentPos('slide-up')
        }else{
          setEventContentPos('slide-down')
          setShowEventContent(false)}
          console.log("toggleEventContent click")
        }
    function toggleEventMessages(){
      if(!showEventMessages){
        setShowEventMessages(true)
        setEventMessagesPos('slide-up')
        }else{
          setEventMessagesPos('slide-down')
          setShowEventMessages(false)}
          console.log("toggleEventMessages click")
        }
    function toggleEventVote(){
      if(!showEventVote){
        setShowEventVote(true)
        setEventVotePos('slide-up')
        }else{
          setEventVotePos('slide-down')
          setShowEventVote(false)}
          console.log("toggleEventVote click")
        }

    function toggleMeetingVideo(){
      if(!showMeetingVid){
        setShowMeetingVid(true)
        setSlidePos('slide-up')
        }else{
          setSlidePos('slide-down')
          setShowMeetingVid(false)}
          console.log("toggleViewMeeting click")
        }

    function toggleMeetinggMsg(){
      if(!showMtgMsg){
        setMtgMsgPos('slide-up')
        setShowMtgMsg(true)
        setVLinkMove('lnk-msg-mv')
        setmmButtonClass(mm_btn_cls)
      }else{
        setMtgMsgPos('slide-down')
        setShowMtgMsg(false)
        setVLinkMove('')
        
          setmmButtonClass( mm_btn_opn)
          // setmmButtonClass( mm_btn_vt_rst)
        }
        console.log("toggleMtgMsg click")
      }
      
      
      function toggleVtBox(){
        if((!mtgVtBox)){
          setMtgVtPos('slide-up')
          
          setmmButtonClass( mm_btn_vt_mv)
          window.localStorage.setItem('voteToggle',true)
          setMtgVtBox(true)
           }else{
              setMtgVtPos('slide-down')
              window.localStorage.setItem('voteToggle',false)
              setMtgVtBox(false)
              if((!mtgVtBox)&&(showMtgMsg)){
            
                setmmButtonClass( mm_btn_opn)
              }
      
           }
           console.log("toggleMtgVt click")
     }

    function toggleView(){

        if( view === "meetings" && (user) ){
          console.log("[toggleView]: meetings")
      setFrameContent(
        <Meetings  
          user = {user}
          meetings={meetings} 
          votes={votes} 
          view={view} 
          setView={setView}/>
      )
    }else 
    if( view === "meeting" && (votes)){
      console.log("[toggleView]: meeting")
      if(!meeting){
        console.log("No meeting! 😳")
       setView('meetings')
      }
      // setmmButtonClass( mm_btn_cls)
      // setShowMMButton(true)
      set_h_logo_vis(true)
      setShowMeetingVidButton(true)
      setShowEventVidButton(true)
      setFrameContent( <Meeting  
            user = {cur_user}
            meetings={meetings} 
            meeting={currentMeeting} 
            votes={currentMeeting?.votes} 
            view={view} 
            setView={setView}
            msgState={vLinkMove}
            />
            )
    }else 
    if( view === "vote" ){
      console.log("[toggleView]: vote")
      setFrameContent( <Vote  
        user = {cur_user}
            meetings={meetings} 
            votes={votes} 
            view={view} 
            setView={setView}/>
            )
    }else  
    if( view === "create-Meeting" ){
      console.log("[toggleView]: create-Meeting")
      setFrameContent( <ComingSoon 
        user = {cur_user}
            view={view} 
            setView={setView}/>
            )
      // setFrameContent( <CreateMeeting 
      //   user = {cur_user}
      //       view={view} 
      //       setView={setView}/>
      //       )
    }else 
    if( view === "login"){
      axios.put(`${NDAER_ENDPOINT}/viewers/add-viewer/`, {...viewer})
      // console.log("Put viewer?: ", viewer)
      console.log("[toggleView]: login")
      set_h_logo_vis(false)
      setFrameContent( 
        <div className='center'>

        {/* <LoginLogo /> */}
        <Login 
            view={view} 
            setView={setView}/>
        </div>
            )
    }else 
    // if( view === "signup"){
    //   // axios.put(`${NDAER_ENDPOINT}/viewers/add-viewer/`, {...viewer})
    //   // console.log("Put viewer?: ", viewer)
    //   console.log("[toggleView]: signup")
    //   set_h_logo_vis(false)
    //   setFrameContent( 
    //     <div className='center'>

    //     {/* <LoginLogo /> */}
    //     <Signup 
    //         view={view} 
    //         setView={setView}/>
    //     </div>
    //         )
    // }else 
    if( view === "vid-conf"){
      console.log("[toggleView]: vid-conf")
      set_h_logo_vis(true)
      setShowMeetingVidButton(true)
      setShowMMButton(true)
      setFrameContent( <VidConf 
            view={view} 
            setView={setView}/>
            )
    }else 
    if( view === "events"){
      console.log("[toggleView]: events")
      set_h_logo_vis(true)
      // setShowEventVidButton(true)
      // setShowMMButton(true)
      setFrameContent( <Events 
           user = {cur_user}
            events = {events}
            view={view} 
            setView={setView}/>
            )
    }else 
    if( view === "event"){
      console.log("[toggleView]: event")
      set_h_logo_vis(true)
      setShowEventVidButton(true)
      // setShowMMButton(true)
      setFrameContent( <Event 
            event_id = {event?.event_id}
            view={view} 
            setView={setView}/>
            )
    }else 
    if( view === "ndaer"){
      console.log("[toggleView]: login")
      set_h_logo_vis(true)
      setFrameContent( <Ndaer 

            view={view} 
            setView={setView}/>
            )
    }else 
    if( view === 'hub'){
    // if( user?._id ){
      console.log("[toggleView]: hub")
      set_h_logo_vis(true)
      setFrameContent(
        <Hub  
        user = {user.email}
        meetings={meetings} 
        votes={votes} 
        view={view} 
        setView={setView}/>
      )
    }else 
    if( view === "contacts"){
      console.log("[toggleView]: contacts")
      set_h_logo_vis(true)
      setFrameContent(
        <Contacts  
        user = {user.email}
        view={view} 
        setView={setView}/>
      )
    }else 
    if( view === "test"){
      console.log("[toggleView]: test")
      set_h_logo_vis(true)
      setFrameContent( <Test 
            view={view} 
            setView={setView}/>
            )
    }else 
    if( view === "home"){
      console.log("[toggleView]: home")
      set_h_logo_vis(true)
      setFrameContent( <Home 
            view={view} 
            setView={setView}/>
            )
    }
    else{

        console.log("[toggleView]: default - empty content")
        console.log("[toggleView] view: ",view)
        setFrameContent(
        //  <Error />
        )
      }
        return frameContent
    }
    function backClick(){
      switch(view){
        case 'meeting':
          window.location.href = `/meetings`
          break;
        case 'events':
          window.location.href = `/hub`
          break;
        case 'event':
          window.location.href = `/events`
          break;
        case 'create-Meeting':
          window.location.href = `/meetings`
          break;
        case 'vote':
          window.location.href = `/meeting`
          break;
        case 'ndaer':
          window.location.href = `/meeting`
          break;
        case 'vid-conf':
          window.location.href = `/meeting`
          break;
        case 'meetings':
          window.location.href = `/hub`
          break;
        case 'contacts':
          window.location.href = `/hub`
          break;
        case 'hub':
          window.location.href = `/`
          break;
        case 'home':
          window.location.href = `/`
          break;
          case 'test':
            window.location.href = `/hub`
            break;
          }
        }
        const  handleLogout = () =>{
          setUser({})
          localStorage.clear('TH_user')
          localStorage.clear('TH_meetings')
          // localStorage.clear('cur_user')
          setView('home')
          console.log('Logged out (should be empty):', user, view)
          window.location.href = `/`

    }
    function backview(){
      switch(view){
        case 'meeting':
          setPrevView('meetings')
          back_route = `/meetings`
          break;
        case 'events':
          setPrevView('hub')
          back_route = `/hub`
          break;
        case 'event':
          setPrevView('events')
          back_route = `/events`
          break;
        case 'create-Meeting':
          setPrevView('meetings')
          back_route = `/meetings`
          break;
          case 'vote':
          setPrevView('meeting')
          back_route = `/meeting`
          // window.location.href = `/meeting`
          break;
        case 'meetings':
          setPrevView('hub')
          back_route = `/hub`
          // window.location.href = `/`
          break;
        case 'contacts':
          setPrevView('hub')
          back_route = `/hub`
          // window.location.href = `/`
          break;
        case 'vid-conf':
          setPrevView('meeting')
          back_route = `/`
          // window.location.href = `/`
          break;
        case 'ndaer':
          setPrevView('meeting')
          back_route = `/meeting`
          // window.location.href = `/`
          break;
        case 'hub':
          setPrevView('home')
          back_route = `/`
          // window.location.href = `/`
          break;
        case 'signup':
          setPrevView('home')
          back_route = `/`
          // window.location.href = `/`
          break;
        case 'test':
          setPrevView('hub')
          back_route = `/hub`
          // window.location.href = `/`
          break;
      }
    }
    useEffect(()  => {
      backview()
      // fetchUser(user,token)
      if(!frameContent){
        toggleView()
        // document.addEventListener('load',()=>{
          // console.log("clearing vote.")
          setmmButtonClass(mm_btn_vt_rst)
          // window.localStorage.setItem('voteToggle',false)
          // window.localStorage.setItem('vote',JSON.stringify(''))
        // })
      }
      setMtgVtBox(JSON.parse(window.localStorage.getItem('voteToggle')))
      if(!mtgVtBox){
          toggleVtBox()
          console.log("[Meeting]  mtgVtBox:", mtgVtBox)
       }
       
      // if (!cur_user){
        // 
        // console.log("[Frame] cur_user:",cur_user)
        // window.localStorage.setItem('cur_user',JSON.stringify(cur_user))
        // set_cur_user(JSON.parse(window.localStorage.getItem('cur_user')))
        // set_cur_user(guest.email)

      
        // }else{set_cur_user("ajph03nix@gmail.com")}
      // let  vote = JSON.parse(window.localStorage.getItem('vote'))
      },[view])
     
      function routeHome(){
        console.log("window.location.href:", window.location.href)
        if ((window.location.href  === "http://localhost:3000/") || (window.location.href  === "https://townhall.netlify.app")){
        console.log("go to meetings!")
        window.location.href = `/hub`
      }else{
        console.log("here!")
        window.location.href = `/hub`
      }
    }
  
    function checkVtToggle(){
      setMtgVtBox(JSON.parse(window.localStorage.getItem('voteToggle')))
      console.log("[Frame] checkVtToggle mtgVtBox: ",mtgVtBox)
      if(!mtgVtBox){
        toggleVtBox()
      }
        
    }
    function routeMeetings(){
      window.location.href = `/meetings`
    }
    useEffect(() => {
     
    }, [view,currentMeeting])
    


    let vidLinkClass = `vid-link ${vLinkMove} blink-faster`
    let mtg_vt_cls_ButtonClass = `vc-mt-vt-button show-box blink`
    return (
        <div className="container">
           a dynamic place to meet
        <div className="header">
          <div className="frame-logo-wrap">
          <div className="header-logo" id="header-logo" onClick={toggleHubSlide}>
          {/* <div className="header-logo" onClick={routeHome}> */}
            {/* {!h_logo_vis&&(<span ><h1>*    &nbsp;   *</h1></span>)} */}
           {h_logo_vis &&(<img src ="./images/TownHall_Logo_v2_3_2.png" alt="townhall logo" value="home"/>)}
          </div>
          </div>
          <img src ="./images/BoardL.png" alt ="Left Border Board"/>
        </div>

        <div className="body" id="body">

          <div className="body-left">
            <img src ="./images/BoardB.png" alt ="Bottom Border Board"/>
          </div>

          <div className="body-center">
         {/* ========Vote Close button======== */}
          {/* {((view === 'vid-conf') && (mtgVtBox))&&(<div 
              onClick={toggleVtBox} 
              className={mtg_vt_cls_ButtonClass}
              id = "vc-mt-vt-button">
                       <div className ="blink">
                        <img src="./images/close-x.svg" alt="close icon"/>
                      </div>
                     
                     </div>)} */}
           {/* ========Meeting Messages Toggle======== */}
          {/* {((props.view === 'meeting') && (props.view !== 'vid-conf' )) &&( <div className={vidLinkClass}>
              <a href='/vid-conf'>
                  <img src='/images/V_Meet_Icon_wht.svg' alt='Video Conference Link' />
              </a>
            </div>)} */}

          {/* {showVMButton&&(<div  */}
          {/* { view ==="meeting" &&(<div 
              
              onClick={toggleMeetingVideo} 
              className="frame-vm-button color-grad-blue-text" >
                       <div> <h6>{showMeetingVid?"hide":"show"}</h6> </div>
                       <div>meeting</div>
                     </div>)} */}
        
            {/* ========Event/Meeting video Toggle======== */}
          {showEventVidButton&&(<div 
              onClick={toggleEventVideo} 
              className="frame-vm-button color-grad-blue-text" >
                       <div> <h6>{showEventVid?"hide":"show"} live</h6> </div>
                       <div>{view==="event"?"event":"meeting"}</div>
                     </div>)}
        
            {/* ========Event/Meeting space  Toggle======== */}
          {((view ==="meeting"||"event")&& (showEventVid) || (showEventContent) || (showEventMessages) || (showEventVote))&&(<div 
              onClick={toggleSpaceView} 
              className="frame-view-content-button color-grad-blue-text" >
                       <div> <h6>{showSpaceView?"hide":"show"} </h6> </div>
                       {/* <div>{view==="event"?"event":"meeting"} */}
                       <h6>space</h6> 
                       {/* </div> */}
                     </div>)}
        
            {/* ========Event Toggles======== */}
            {showEventVidButton && (<div className='eventToggles frame-event-toggle-tab' id='eventToggles'>
            <div className="blink" id="eventMessageToggle" onClick={toggleEventMessages}>
                <img src='./images/Chatbox-outline-01.svg' alt ="Event Messages Link"/>
            </div>
            <div className="blink" id="eventContentToggle" onClick={toggleEventContent} >
                <img src='./images/film-solid.svg' alt ="Event Content Link"/>
            </div>
            <div className="blink" id="eventVoteToggle" onClick={toggleEventVote}>
                <img src='./images/scale-balanced-solid.svg' alt ="Event Messages Link"/>
            </div>
         </div>)}

            <div className="body-grad">&nbsp;</div>
            {h_logo_vis &&(<div className="body-interf-1 center color-grad-blue-border" id="mainframe">
            {/* &nbsp; */}
           {showHubSlide && ( <div className={`hub-slide ${hubSlidePos}`}>
              <Hub />
           </div>)}

            {/* ========In Meeting Vote======== */}
            {/* {((view === "vid-conf") ) &&(  */}
           {((view === "vid-conf") && mtgVtPos === 'slide-up') &&( 
             <div className = {mtgVtPos} id="vc-vt-frame">
                  <Vote  
                      user = {cur_user}
                      vote = {props.vote}
                      meetings = {meetings} 
                      votes = {meeting.votes} 
                      view = {props.view} 
                      setView = {props.setView}/>   
                </div>
                )}  

            {/* ========In Meeting Messages======== */}

            {((view === "vid-conf" || "meeting") &&  MtgMsgPos) &&( 
              <div className ={MtgMsgPos} id="v-m-frame">
                <MeetingMessages  
                user = {cur_user}
                meetings = {meetings} 
                votes = {votes} 
                view = {view} 
                setView = {setView}/> 
              </div>
            )}  

             
            {/* ========Meeting Messages======== */}
            {((view === "meeting") &&  eventMessagesPos) &&( 
              <div className = {eventMessagesPos} id="v-m-frame-mm">
                <MeetingMessages 
                user = {cur_user}
                // event_id = {event.event_id} 
                votes = {votes} 
                view = {view} 
                setView = {setView}/> 
              </div>
            )}  
            {/* ========Meeting Content======== */}
            {((view === "meeting") &&  eventContentPos) &&( 
              <div className ={eventContentPos} id="v-m-frame-mc">
                <MeetingContent 
                user = {cur_user}
                // event_id = {event.event_id} 
                votes = {votes} 
                view = {view} 
                setView = {setView}/> 
              </div>
            )}  
           
            {/* ========Meeting Vote======== */}
            {((view === "meeting") &&  eventVotePos) &&( 
              <div className = {eventVotePos} id="v-m-frame-mv">
                {/* <MeetingVote 
                user = {cur_user}
                vote = {props.vote}
                meetings = {meetings} 
                event = {event} 
                // id = {event.event_id?event.event_id:meeting.meeting_id} 
                votes = {votes} 
                view = {view} 
                setView = {setView}/>  */}
                <ComingSoon 
        user = {cur_user}
            view={view} 
            setView={setView}/>
              </div>
            )} 

            {/* ========Meeting Video======== */}

            {((view === "meeting") &&  eventVidPos) &&( 
              <div className ={eventVidPos} id="v-m-frame-vc">
                <VidConf 
                user = {cur_user}
                // event_id = {event.event_id?event.event_id:meeting.meeting_id} 
                // id = {event.event_id?event.event_id:meeting.meeting_id} 
                votes = {votes} 
                view = {view} 
                setView = {setView}/> 
              </div>
            )} 

            {/* -------------========Event========-------------*/}
            
           
            {/* ========Event Messages======== */}
            {((view === "event") &&  eventMessagesPos) &&( 
              <div className ={eventMessagesPos} id="v-m-frame-em">
                <EventMessages 
                user = {cur_user}
                event_id = {event.event_id} 
                votes = {votes} 
                view = {view} 
                setView = {setView}/> 
              </div>
            )}  
             
            {/* ========Event Content======== */}
            {((view === "event") &&  eventContentPos) &&( 
              <div className ={eventContentPos} id="v-m-frame-ec">
                <EventContent 
                user = {cur_user}
                event_id = {event.event_id} 
                votes = {votes} 
                view = {view} 
                setView = {setView}/> 
              </div>
            )}  
            {/* ========Event Vote======== */}
            {((view === "event") &&  eventVotePos) &&( 
              <div className ={eventVotePos} id="v-m-frame-ev">
                <EventVote 
                user = {cur_user}
                event_id = {event.event_id} 
                votes = {votes} 
                view = {view} 
                setView = {setView}/> 
              </div>
            )}  

           {/* ========Event Video======== */}

            {((view === "event") &&  eventVidPos) &&( 
              <div className ={eventVidPos} id="v-m-frame-vc">
                <VidConf 
                user = {cur_user}
                event_id = {event.event_id} 
                votes = {votes} 
                view = {view} 
                setView = {setView}/> 
              </div>
            )}  

           {/* ========CUrrent Space View======== */}
           
           {(showSpaceView) &&( 
            <div className = {spaceViewPos} id="v-m-frame-ss" >
           {/* onClick={checkVtToggle}> */}
              { view === "meeting" &&( <Meeting  
              user = {cur_user}
              meetings={meetings} 
              votes={votes} 
              view={view} 
              setView={setView}
              msgState={vLinkMove}
              /> )}
              { view === "event" &&( <Event  
              user = {cur_user}
              event_id = {event.event_id} 
              meetings={meetings} 
              votes={votes} 
              view={view} 
              setView={setView}
              msgState={vLinkMove}
              /> )}
            </div>
            )}  
            

              {frameContent}
              
              
            </div>)}
            
            {/* {(showMeetingVid || view ==='meeting'|| MtgMsgPos ==="slide-up")&&(<div 
              onClick={toggleMtgMsg} 
              className={mmButtonClass}
              id = "frame-mm-button">
                       <div className ="blink">
                        <img src="./images/Chatbox-outline-01.svg" alt="messgages icon"/>
                      </div>
                     
                     </div>)} */}

           

            {/* =====HOME===== */}
            {/* {!user?.token &&(
              <Home />  )} */}
             {/* <> */}
            {/* <div className="body-interf-2 center color-grad-blue-border" id="mainframe">&nbsp;
              <div id='top-z'>
              <LoginLogo />
              <div >
              <Login 
                view={view} 
                setView={setView}/>
           </div>
            </div> */}
                            {/* {frameContent} */}
                {/* <div className="rot-bg center">
                  <div className="sphere-wrap center"> 
                    <div className="login-top sun">
                      <img src="./images/Sun_01.png" alt ="sun"/>
                    </div>
                    <div className="login-bottom moon">
                      
                        <img src="./images/Moon_01.png" alt ="moon"/> */}
                      {/* <h1>moon</h1> */}
                    {/* </div>
                    </div>
                  <div className="cloud-div">  
                    <img src="./images/Cloud_01.png" alt ="cloud"/>
                  </div>
              </div>
            </div> */}
            {/* </>
             )} */}
            
            <img src ="./images/BoardCenter.png"/>
          </div>

          <div className="body-right">
            <img src ="./images/BoardT.png"/>
          </div>

        </div>

        <div className="footer">
          <img src ="./images/BoardL.png"/>
          
          {h_logo_vis&&(<div onClick={(view !== 'hub')?backClick:handleLogout} className="frame-back-button color-grad-blue-text " >
                       <div>
                         {(view === 'home')
                            ?<h5>welcome</h5>
                            : <h6>back to</h6> }
                        </div>
                       <div> {(view !== 'hub')?prev_view:'login'} </div>
                     </div>)}
        </div>
        
      </div>
  );
}
export default Frame; 